import { render, staticRenderFns } from "./ChristmasPane.vue?vue&type=template&id=2131e83a&scoped=true&"
import script from "./ChristmasPane.vue?vue&type=script&lang=js&"
export * from "./ChristmasPane.vue?vue&type=script&lang=js&"
import style0 from "./ChristmasPane.vue?vue&type=style&index=0&id=2131e83a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2131e83a",
  null
  
)

export default component.exports